import { LuFeather } from 'react-icons/lu'
import { cn } from '@/utils/cn'

/**
 * Says the learner wrote this entry themselves.
 *
 * Not a source badge: a custom flashcard has no `word_senses.source` to key on,
 * so this one stays hard-coded while everything that *does* come from a source
 * is configured by an admin (see SourceBadge).
 *
 * A marker is a glyph **plus a short visible label** — never a bare icon. The
 * label is what makes the meaning readable with no interaction at all, which a
 * hover tooltip cannot do on touch and sr-only text cannot do for sighted eyes.
 * The fuller explanation rides along for assistive technology and pointer users.
 */

const EXPLANATION = 'you wrote this yourself'

export function ProvenanceMarker({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 align-middle shrink-0',
        'text-[11px] font-light uppercase tracking-wider select-none',
        'text-provenance-custom',
        className,
      )}
    >
      {/* Glyph and short label are the sighted channel, and `title` gives pointer
          users the long form. All hidden from assistive tech so the sr-only text
          below is announced once — a `title` here as well makes NVDA/JAWS read
          the explanation twice. */}
      <span aria-hidden="true" title={EXPLANATION} className="inline-flex items-center gap-1">
        <LuFeather aria-hidden="true" size={12} />
        yours
      </span>
      <span className="sr-only">{EXPLANATION}</span>
    </span>
  )
}
